import { createApp } from 'vue';

import '@nedap/unrux/dist/unrux.css';
import '@nedap/unrux/scss/colors.scss';
import '../stylesheets/fonts/fonts.scss';

import { EnvironmentIndicator, Footer } from '@nedap/unrux';

import 'components/session/session.scss';

import { hardenInDomTemplates } from 'helpers/harden-in-dom-templates';

const app = createApp({
  components: {
    EnvironmentIndicator,
    'x-footer': Footer,
  },
});

hardenInDomTemplates(app);

app.mount('#app');
